'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.adminBusinessUnits', [])

.factory('adminBusinessUnitsService', ['$http', '$q', function ($http, $q) {
    var service = {};

    var baseUrl = environment.apiUrl + '/ID/BusinessUnit/API';

    /* Get all business units */
    service.searchBusinessUnits = function (searchTerm) {
        return $http
            .get(baseUrl + "?searchTerm=" + encodeURI(searchTerm))
            .then(function (response) {
                return response.data;
            });
    }

    /* Update business unit's informations */
    service.updateBusinessUnit = function (businessUnit) {
        return $http
            .put(baseUrl + "/" + businessUnit.BusinessUnitID, businessUnit)
            .then(function (response) {
                return response.data;
            });
    }

    /* Get business unit's informations */
    service.getBusinessUnit = function (BusinessUnitID) {
        return $http.get(baseUrl + "/" + BusinessUnitID);
    }

    /* Create new business unit */
    service.createBusinessUnit = function (businessUnit) {
        return $http
            .post(baseUrl, businessUnit)
            .then(function (response) {
                return response.data;
            });
    };

    /* Remove business unit */
    service.deleteBusinessUnit = function (businessUnit) {
        return $http
            .delete(baseUrl + "/" + businessUnit.BusinessUnitID)
            .then(function (response) {
                return response.data;
            });
    };

    /* Set Non Primary Business Unit For Employee */
    service.setNonPrimaryBusinessUnitForEmployee = function (businessUnitId, employeeId) {
        var reqUrl = baseUrl + '/Non/Primary/' + businessUnitId + '/For/Member/' + employeeId;

        return $http
                .post(reqUrl)
                .then(function (response) {
                    return response.data;
                });
    };

    /* Set Primary Business Unit For Employee */
    service.setPrimaryBusinessUnitForEmployee = function (employeeId) {
        var reqUrl = baseUrl + '/Primary/For/Member/' + employeeId;

        return $http
                .post(reqUrl)
                .then(function (response) {
                    return response.data;
                });
    };

    /* Synchronize member impacted by BU modifications */
    service.synchronizeUpdates = function () {
        return $http.post(baseUrl + "/SyncImpacted");
    };

    return service;
}]);
